import { createFileRoute } from '@tanstack/react-router';

import ProductPropertiesPage from '@/components/products/specific/PropertiesPage';

export const Route = createFileRoute('/products/$id/properties')({
	component: ProductPropertiesPage,
});
